<script lang="ts">
    import { ActiveTopicStore, ActiveTopic } from "$/stores/extension/ActiveTopicStore";
    import { currentSelectionStore} from "$/stores/PageSelectStore";
    import { addHoverClass, removeHoverClass } from "../utils";
    import type {Topic} from "../types";

    export let optionSelected: (topic: Topic) => void;

    let inboxTopic = {
        id: null,
        name: "Inbox",
        archived: false,
        createdOn: 0,
        tenant: $ActiveTopic?.tenant,
        tenantId: $ActiveTopic?.tenantId,
        snippets: null,
        createdBy: {},
        createdById: "",
        publicRole: 0,
        public: false,
        roles: [],
    };

    $: isSelected = $ActiveTopic?.id === null;
    $: isArrowSelected = $currentSelectionStore?.clusterIndex === -1 && $currentSelectionStore?.topicIndex === -1;

    function handleTopicSelection(topic) {
        optionSelected(topic);
    }
</script>

<span
    class="inbox-option"
    class:selected={isSelected}
    class:arrow-selected={isArrowSelected} 
    on:click={() => handleTopicSelection(inboxTopic)}
    on:keydown|preventDefault|stopPropagation
    on:keyup|preventDefault|stopPropagation
    on:keypress|preventDefault|stopPropagation
    on:mouseenter={addHoverClass}
    on:mouseleave={removeHoverClass}
>
    <div class="settings-icon">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M9 3.75H6.912a2.25 2.25 0 0 0-2.15 1.588L2.35 13.177a2.25 2.25 0 0 0-.1.661V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 0 0-2.15-1.588H15M2.25 13.5h3.86a2.25 2.25 0 0 1 2.012 1.244l.256.512a2.25 2.25 0 0 0 2.013 1.244h3.218a2.25 2.25 0 0 0 2.013-1.244l.256-.512a2.25 2.25 0 0 1 2.013-1.244h3.859M12 3v8.25m0 0-3-3m3 3 3-3"
            />
        </svg>
    </div>
    <span class="option-title"> Inbox </span>
</span>

<style>
    .inbox-option {
        @apply reset flex cursor-pointer flex-row items-center gap-2 border-b border-solid border-gray-200 bg-white px-4 text-gray-800 hover:bg-gray-300 !important;
    }

    .option-title {
        @apply reset h-8 text-sm leading-8 !important;
    }

    .settings-icon {
        @apply inline-block h-4 w-4 text-center text-sm !important;
    }

    .arrow-selected {
        @apply bg-gray-100 !important;
    }
</style>
